var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglelink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1454_513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.22852,
    y: 2.13159,
    width: 60.3516,
    height: 60.3516,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2952 19.7155C25.9658 20.1108 25.7995 20.6168 25.8303 21.1304V43.4849C25.7995 43.9985 25.9658 44.5045 26.2952 44.8997L26.3659 44.9705L38.8873 32.4592V32.1661L26.3659 19.6448L26.2952 19.7155Z",
    fill: "url(#paint0_linear_1454_513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0307 36.6329L38.8872 32.4591V32.1661L43.0307 27.9822L43.1216 28.0327L48.0837 30.8523C49.4985 31.6507 49.4985 32.9645 48.0837 33.7729L43.1418 36.5824L43.0307 36.6329Z",
    fill: "url(#paint1_linear_1454_513)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1523 36.5724L38.8875 32.3076L26.2954 44.8997C26.5838 45.1532 26.9517 45.298 27.3355 45.3091C27.7193 45.3202 28.0949 45.1968 28.3975 44.9604L43.1624 36.5724",
    fill: "url(#paint2_linear_1454_513)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1521 28.0429L28.3872 19.6549C28.0847 19.4184 27.7091 19.295 27.3252 19.3061C26.9414 19.3172 26.5735 19.462 26.2852 19.7155L38.8874 32.3076L43.1521 28.0429Z",
    fill: "url(#paint3_linear_1454_513)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.031 36.4814L28.3874 44.8189C28.0956 45.0371 27.7411 45.1549 27.3768 45.1549C27.0124 45.1549 26.6579 45.0371 26.3662 44.8189L26.2954 44.8897L26.3662 44.9604C26.6573 45.1801 27.012 45.299 27.3768 45.299C27.7415 45.299 28.0962 45.1801 28.3874 44.9604L43.1523 36.5724L43.031 36.4814Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M26.2952 44.7582C25.9658 44.363 25.7995 43.857 25.8303 43.3434V43.495C25.7995 44.0086 25.9658 44.5146 26.2952 44.9098L26.3659 44.8391L26.2952 44.7582ZM48.0838 33.6214L43.0307 36.4814L43.1217 36.5724L48.0838 33.7629C48.3653 33.6306 48.607 33.4264 48.7844 33.1709C48.9619 32.9154 49.0688 32.6176 49.0944 32.3076C49.0375 32.5893 48.9169 32.8542 48.7417 33.0819C48.5665 33.3097 48.3414 33.4942 48.0838 33.6214Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M28.3872 19.7959L48.0839 30.9933C48.3416 31.1205 48.5666 31.3051 48.7418 31.5328C48.917 31.7606 49.0377 32.0255 49.0945 32.3071C49.0689 31.9971 48.962 31.6993 48.7846 31.4438C48.6071 31.1883 48.3654 30.9841 48.0839 30.8519L28.3872 19.6544C26.9724 18.856 25.8203 19.523 25.8203 21.14V21.2916C25.8506 19.6645 26.9825 18.9975 28.3872 19.7959Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1454_513",
    x: 0.728515,
    y: 0.131592,
    width: 71.3516,
    height: 71.3516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1454_513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1454_513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1454_513",
    x1: 37.7756,
    y1: 20.8979,
    x2: 20.8177,
    y2: 37.8558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1454_513",
    x1: 49.9331,
    y1: 32.3076,
    x2: 25.4866,
    y2: 32.3076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1454_513",
    x1: 40.838,
    y1: 34.632,
    x2: 17.8367,
    y2: 57.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1454_513",
    x1: 23.122,
    y1: 12.2775,
    x2: 33.3897,
    y2: 22.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelink);
export default __webpack_public_path__ + "static/media/googlelink.7d760dccfa557bc72e64f029a19bf3f8.svg";
export { ForwardRef as ReactComponent };